import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { lazy } from 'react';
import { render } from 'react-dom';
import { AppContextProvider } from './common/context/AppContext';
import { arqConfig } from './config';
import { i18nextInitializer } from './config/i18next/i18next-config';
import './index.css';
import { ErrorPage } from './pages/ErrorPage';
import { CustomSpinner } from './components/atoms/CustomSpinner';
import { ArchitectureProvider } from '@andbank-myinvestor/arq/lib/basic-operation';

declare global {
	interface Window {
		dataLayer: any // Habilitar dataLayer para ser accedido desde TS
    MAUI_APP: any
		getFileFromDevice: Function
		MAUI_APP_IOS: any
		webkit?: {
			messageHandlers?: {
				OpenGoogleWallet?: {
					postMessage: (message: any) => void;
				};
				OpenAppleWallet?: {
					postMessage: (message: any) => void;
				};
				PositionForNativeButton?: {
					postMessage: (message: any) => void
				}
				RemoveNativeButton?: {
					postMessage: (message: any) => void
				}
				getTokenHeader?: {
					postMessage: (message: any) => void
				}
				getCardActivationState?: {
					postMessage: (message: any) => void
				}
				updateSplashCount?: {
					postMessage: (message: any) => void
				}
			};
		};
		requestTokenHeader?: () => void
		onWalletResult?: (status: string, text: string) => void
		Android?: {
			OpenGoogleWallet: () => void;
		};
		Ios?: {
			OpenAppleWallet: () => void;
		};
		onCardActivationStateResult?: (status: string) => void
		getSplashCount?: (counter: number) => void;
		openNotificationSettings?: () => void;
		ReactNativeWebView?: {
			postMessage: (message: string) => void;
		};
		BIOMETRIC_V2_SUPPORTED?: boolean;
		onBiometricRegistered?: (success: boolean) => void;
		onBiometricDisabled?: (success: boolean) => void;
		onBiometricMigrationCheck?: (result: { needs_migration: boolean; registered?: boolean; available?: boolean; invalidated_reason?: string | null }) => void;
	}
}

const App = lazy(() => import('./App'));

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			staleTime: 30000,
			cacheTime: 60000
		}
	}
});

render(
	<QueryClientProvider client={queryClient}>
		{/* devtools para react-query, solo se introducen en desarrollo process.env.NODE_ENV=development */}
		{/* las mutaciones no aparecen en la devtool https://github.com/tannerlinsley/react-query-devtools/issues/31#issuecomment-655794286 */}
		{false && <ReactQueryDevtools initialIsOpen={false} />}
		<AppContextProvider>
			<ArchitectureProvider
				config={arqConfig}
				Idle={() => <div style={{ minHeight: "100vh" }}><CustomSpinner fullScreen={true} /></div>}
				Error={props => <ErrorPage {...props} fatalError={true} />}
				LazySuccessComponent={App as any}
				customInitializer={i18nextInitializer}
			/>
		</AppContextProvider>
	</QueryClientProvider>,
	document.getElementById('root')
);
